import { render, staticRenderFns } from "./DialogPageChatListItem.vue?vue&type=template&id=6c2df170"
import script from "./DialogPageChatListItem.vue?vue&type=script&lang=js"
export * from "./DialogPageChatListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports